// extracted by mini-css-extract-plugin
export default {"textarea":"FormTextArea_textarea__gbYa+"};